import {apiClient} from "@/state/modules/apiClient";
const controller = "Statistical";

export const actions = {
    async getAll({commit}, value) {
        return apiClient.get(controller + "/get-tong-so" );
    },
    async getTungNam({commit}, value) {
        return apiClient.get(controller + "/get-tung-nam" );
    },

    async getDanhGiaTungNam({commit}, value) {
        return apiClient.get(controller + "/get-danh-gia-tung-nam" );
    },
};
